import { Link } from "react-router-dom";
import { FOOTER } from "@/constants/testIds";

// Real, downloadable PDFs — regenerate via /app/scripts/generate_pdfs.py
const pdfs = [
  { slug: "wholesale-application", label: "Wholesale Account Application", href: "/downloads/wholesale-application.pdf" },
  { slug: "livestock-declaration", label: "Livestock Movement Declaration", href: "/downloads/livestock-declaration.pdf" },
  { slug: "food-chain-info", label: "Food Chain Information (FCI)", href: "/downloads/food-chain-info.pdf" },
  { slug: "rate-card", label: "Rate Card & Kill Sheet Request", href: "/downloads/rate-card.pdf" },
];

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-[color:var(--ink)] text-[color:var(--cream)] pt-16 md:pt-32 pb-10"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14">
        <div className="md:col-span-5">
          <div className="font-ui text-[10px] md:text-[11px] uppercase tracking-editorial text-[color:var(--mustard)]">Est. c.1924</div>
          <h3 className="font-display text-[12vw] sm:text-4xl md:text-6xl leading-[0.95] tracking-tightest mt-3">
            F. Drury <span className="italic text-[color:var(--mustard)]">&amp;</span> Sons
          </h3>
          <p className="font-body italic text-base md:text-xl text-[color:var(--cream)]/80 mt-5 md:mt-6 max-w-md">
            A Wiltshire abattoir and wholesale butcher — over a hundred years of craft, welfare and traceability.
          </p>
          <div className="mt-6 md:mt-8 flex gap-3 md:gap-4 flex-wrap">
            <Link to="/wholesale" className="btn-sharp-outline" style={{ borderColor: "var(--cream)", color: "var(--cream)" }}>
              Wholesale accounts
            </Link>
            <Link to="/contact" className="btn-sharp" style={{ background: "var(--mustard)", color: "var(--ink)", borderColor: "var(--mustard)" }}>
              Enquire
            </Link>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="font-ui text-[10px] md:text-[11px] uppercase tracking-editorial text-[color:var(--mustard)] mb-4 md:mb-6">Visit</div>
          <address className="not-italic font-body text-base md:text-lg leading-relaxed text-[color:var(--cream)]/90">
            The Abattoir, Tockenham,<br />
            Wootton Bassett, Swindon,<br />
            Wiltshire, SN4 7PF
          </address>
          <div className="mt-5 md:mt-6 font-ui text-sm space-y-1 text-[color:var(--cream)]/80">
            <div>Telephone · <a href="tel:01793852467" className="link-underline">01793 852467</a></div>
          </div>
        </div>

        <div className="md:col-span-4">
          <div className="font-ui text-[10px] md:text-[11px] uppercase tracking-editorial text-[color:var(--mustard)] mb-4 md:mb-6">Forms &amp; downloads</div>
          <ul className="space-y-3 md:space-y-4">
            {pdfs.map((p) => (
              <li key={p.slug}>
                <a
                  href={p.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                  data-testid={FOOTER.pdfLink(p.slug)}
                  className="group flex items-center justify-between gap-3 border-b border-[color:var(--cream)]/15 py-3 hover:border-[color:var(--mustard)] transition-colors duration-500"
                >
                  <span className="font-body text-base md:text-lg">{p.label}</span>
                  <span className="font-ui text-[10px] uppercase tracking-editorial text-[color:var(--cream)]/60 group-hover:text-[color:var(--mustard)] transition-colors duration-500 shrink-0">
                    PDF ↓
                  </span>
                </a>
              </li>
            ))}
          </ul>
          <p className="mt-5 md:mt-6 font-body italic text-sm text-[color:var(--cream)]/60">
            Prefer a printed copy? Pop in to the abattoir office and we'll oblige.
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-[1600px] px-5 md:px-10 mt-14 md:mt-20 pt-6 md:pt-8 border-t border-[color:var(--cream)]/15 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div className="font-ui text-[10px] md:text-xs uppercase tracking-editorial text-[color:var(--cream)]/60">
          © {new Date().getFullYear()} F. Drury &amp; Sons Ltd · Company No. 00610856
        </div>
        <div className="flex gap-4 md:gap-6 font-ui text-[10px] md:text-xs uppercase tracking-editorial text-[color:var(--cream)]/60">
          <Link to="/about" className="link-underline">Heritage</Link>
          <Link to="/wholesale" className="link-underline">Wholesale</Link>
          <Link to="/contact" className="link-underline">Contact</Link>
        </div>
      </div>
    </footer>
  );
}
